import { observer } from 'mobx-react-lite'
import { type FC, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { type ActionItem, Button, ContainerHeader } from 'shared/ui'
import { type PageLayoutStore } from 'shared/layout'
import { LINK_BROADCAST_HELP_GUIDE } from 'shared/constants/links'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IBroadcastsHeaderProps = {
  title: string
  pageLayoutStore: PageLayoutStore
}

export const BroadcastsHeader: FC<IBroadcastsHeaderProps> = observer(
  ({ title, pageLayoutStore }) => {
    const { broadcastStore } = useEntitiesContext()
    const { isEmptyState } = broadcastStore
    const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore

    const navigate = useNavigate()
    const onClick = () => {
      navigate(`/${BroadcastsRoutes.root}/${BroadcastsRoutes.create}`)
    }

    const actions: ActionItem[] = useMemo(() => {
      if (isEmptyState) {
        return []
      }
      return [
        {
          iconButtonComponent: (
            <Button
              tag='a'
              text='Help guide'
              size='medium'
              contained='secondary'
              iconProps={{ icon: 'info' }}
              href={LINK_BROADCAST_HELP_GUIDE}
              style={{ textDecoration: 'none' }}
              target='_blank'
              rel='noreferrer'
            />
          ),
        },
        {
          iconButtonComponent: (
            <Button
              text={'New broadcast'}
              onClick={onClick}
              iconProps={{ icon: 'add' }}
              size={'medium'}
            />
          ),
        },
      ]
    }, [isEmptyState])
    return (
      <ContainerHeader
        height={72}
        title={title}
        titleVariant={'heading-md'}
        actions={actions}
        titleIconProps={titleIconProps}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        titleIconAction={headerMenuIconAction}
        actionsGap={8}
        paddingLeft={20}
        paddingRight={20}
      />
    )
  }
)
